import React from 'react';
import LegalLayout from '../components/common/LegalLayout';

const RefundPolicyPage = () => (
  <LegalLayout
    title="환불 정책"
    subtitle="멘토 사례비를 보장하면서 학생의 환경 변화도 합리적으로 반영하는 환불 기준입니다."
    helmetDescription="ElectroWave Club 환불 정책 — 직접 입금 구조에서의 환불 기준, 진행률 구간별 정산, 일시중지 정책."
    accentColor="#6366f1"
  >
    <h2>1. 기본 원칙</h2>
    <p>
      ElectroWave Club은 학생-멘토를 직접 연결하는 매칭 서비스이며, 회비는 <strong>매월 4회차(주 1회 기준
      한 달치)를 기본 단위로 선불 납부</strong>합니다. 학생이 멘토 계좌로 직접 입금하며, 환불 또한 본
      정책 기준에 따라 멘토와 학생 사이에서 정산됩니다. 클럽은 회비를 보관·대리 수령하지 않고,
      분쟁 발생 시 정책 해석과 중재만을 지원합니다.
    </p>
    <p>
      멘토의 사례비는 사전에 약속된 회차와 시간을 기준으로 발생하므로, <strong>이미 진행된 회차의 사례비는
      환불되지 않으며</strong>, 잔여 회차에 한해서만 환불이 가능합니다.
    </p>

    <h2>2. 회차별 환불 기준 (월 4회차 단위)</h2>
    <p>
      해당 달의 정기 미팅 진행 상태에 따라 다음과 같이 산정합니다. 비율은 그 달에 선불 납부한 월 회비
      기준이며, 학생의 일방적 불참(노쇼)으로 진행되지 못한 회차는 진행된 것으로 간주합니다.
    </p>
    <table>
      <thead>
        <tr>
          <th>해당 월 진행 상태</th>
          <th>환불 금액</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td data-label="진행 상태">1회차 시작 전 (당월 미진행)</td>
          <td data-label="환불 금액">월 회비 100% 환불 (이체·송금 수수료 제외)</td>
        </tr>
        <tr>
          <td data-label="진행 상태">1회차 진행 후</td>
          <td data-label="환불 금액">월 회비의 75%</td>
        </tr>
        <tr>
          <td data-label="진행 상태">2회차 진행 후</td>
          <td data-label="환불 금액">월 회비의 50%</td>
        </tr>
        <tr>
          <td data-label="진행 상태">3회차 진행 후</td>
          <td data-label="환불 금액"><strong>월 회비의 25%</strong></td>
        </tr>
        <tr>
          <td data-label="진행 상태">4회차 진행 후</td>
          <td data-label="환불 금액"><strong>환불 불가</strong></td>
        </tr>
      </tbody>
    </table>
    <p>
      이미 4회차를 모두 진행한 달에 대해서는 환불을 청구할 수 없습니다. 다음 달분부터의 중단·환불은
      본 기준에 따라 별도로 정산됩니다.
    </p>

    <h2>3. 첫 달 특례 (매칭 수수료 처리)</h2>
    <p>
      첫 달 매칭에는 클럽 운영을 위한 <strong>매칭 수수료</strong>가 발생하며, 이 수수료는 <strong>멘토가
      클럽에 납부</strong>합니다. 학생이 별도로 매칭 수수료를 내지 않습니다.
    </p>
    <ul>
      <li>첫 달 환불 시에도 위 제2조의 회차별 비율을 동일하게 적용합니다.</li>
      <li>다만 멘토가 이미 클럽에 납부한 <strong>매칭 수수료 등 회수가 어려운 비용은 환불액에서
        제외</strong>되며, 그 차액만큼 학생에게 송금되는 금액이 줄어들 수 있습니다.</li>
      <li>해당 차액은 환불 산정 시 사전에 명시되며, 학생의 동의를 거쳐 정산됩니다.</li>
    </ul>

    <h2>4. 학생 귀책에 의한 미참여 / 일정 변경</h2>
    <p>
      1:1 매칭 특성상 멘토는 사전에 약속된 시간만큼을 비워 두므로, 학생의 사정으로 회차가 진행되지 못할
      경우 멘토의 시간이 회복되지 않습니다. 양측이 납득할 수 있도록 다음 기준을 적용합니다.
    </p>
    <ul>
      <li>
        <strong>일정 변경 요청</strong> — 미팅 시작 <strong>24시간 전</strong>까지 멘토에게 통보하면
        멘토와의 협의를 통해 같은 주 또는 다음 주로 1회 한해 일정 조정이 가능합니다. 조정 가능 여부는
        멘토의 일정에 따릅니다.
      </li>
      <li>
        <strong>지각</strong> — 학생이 미팅 시작 후 늦게 입장하더라도 미팅 종료 시각은 연장되지 않습니다.
        멘토는 약속된 시각부터 약속된 시간만큼 진행한 것으로 봅니다.
      </li>
      <li>
        <strong>사전 통보 없는 불참(노쇼)</strong> — 미팅 시작 24시간 전까지 사전 통보가 없는 미참여는
        해당 회차를 <strong>정상 진행한 것으로 간주</strong>하며, 사례비가 그대로 발생합니다. 보강
        의무는 없습니다.
      </li>
      <li>
        <strong>잦은 일정 변경 / 반복 노쇼</strong> — 1개월 내 일정 변경 3회 이상 또는 노쇼 2회 이상이
        발생할 경우, 멘토는 매칭의 조기 종결을 요청할 수 있습니다. 이 경우 환불은 본 정책 제2조의
        회차별 환불 기준에 따라 산정되며, 노쇼·일정 변경으로 진행된 것으로 간주된 회차는 환불 대상에서
        제외됩니다.
      </li>
      <li>
        <strong>멘토 측 사유</strong> — 멘토 사정으로 미팅이 취소된 경우, 해당 회차는 진행되지 않은
        것으로 보아 동일 회차를 <strong>전액 보강</strong>하거나, 보강이 어려운 경우 학생에게 해당
        회차분 사례비를 환불합니다.
      </li>
    </ul>

    <h2>5. 일시중지 (Pause)</h2>
    <p>
      불가피한 사유(질병, 시험 기간, 단기 출장 등)로 학습을 중단해야 할 때는 환불 대신 <strong>최대 4주
      일시중지</strong>를 신청할 수 있습니다. 일시중지 기간에는 회차가 차감되지 않으며, 재개 시 잔여
      회차가 보장됩니다.
    </p>
    <ul>
      <li>일시중지 신청은 운영자와 멘토에게 <strong>최소 1주일 전 사전 통보</strong> 필요</li>
      <li>1회 신청 최대 2주, 누적 최대 4주까지 가능</li>
      <li>누적 한도를 초과하는 경우 본 환불 정책의 진행률 기준에 따라 환불 또는 종결 처리</li>
    </ul>

    <h2>6. 환불이 어려운 경우</h2>
    <ul>
      <li>이미 진행된 회차의 사례비</li>
      <li>해당 월 4회차를 모두 진행한 경우 (해당 월분)</li>
      <li>첫 달의 매칭 수수료 등 회수가 어려운 운영 비용</li>
      <li>멘토가 별도 제작·전달한 맞춤 자료에 대해 발생한 비용</li>
      <li>학습 결과물(코드, 문서, 자료)을 받은 뒤 진행 자체를 부정하는 신청</li>
      <li>학생의 약관·운영 정책 위반(자료 무단 공개 등)으로 매칭이 종료된 경우</li>
    </ul>

    <h2>7. 환불 절차</h2>
    <ol>
      <li>학생이 운영자(firstman9@protonmail.com)와 멘토에게 환불 의사·사유를 함께 전달</li>
      <li>운영자가 진행률을 확인하고 본 정책 기준에 따라 환불 금액을 산정 (영업일 2일 이내)</li>
      <li>멘토가 산정된 금액을 학생 계좌로 직접 송금 (송금까지 영업일 7일 이내, 송금 수수료는 환불액에서 차감)</li>
      <li>송금 완료 후 운영자에게 확인 통보, 매칭은 종결 처리</li>
    </ol>

    <h2>8. 분쟁 해결</h2>
    <p>
      회비는 학생과 멘토 간에 직접 정산되므로, 환불 기준에 대한 이견은 우선 양측 합의로 해결합니다. 합의가
      어려운 경우 클럽 운영자가 본 정책에 근거하여 중재안을 제시하며, 그래도 합의가 이루어지지 않을
      경우 「전자상거래 등에서의 소비자 보호에 관한 법률」 및 관련 분쟁조정 절차를 따릅니다.
    </p>

    <p style={{ marginTop: 32, fontSize: 13, color: '#666' }}>
      본 환불 정책은 2026년 5월 5일부터 적용됩니다.
    </p>
  </LegalLayout>
);

export default RefundPolicyPage;
